import { getByAuthService } from "../../../../function/helper";

const getShipments = async ({ set, loading, values }) => {
  loading(true);
  const response = await getByAuthService(
    "/external-post/v1/get-external-posts",
    values
  );
  loading(false);

  if (response.status === 200) {
    set(response.data.posts, response.data.count);
  }
};

export default getShipments;
